var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-insights" },
    [
      _c(
        "carousel",
        {
          attrs: { "per-page": 4, navigationEnabled: true, "mouse-drag": false }
        },
        [
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Conversion Rate:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.leadConversionRateNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", { staticClass: "brown_line" }, [
                    _vm._v(_vm._s(_vm.leadConversionRate) + "%")
                  ])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Purchase Intent:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.SalesConversionRateNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.SalesConversionRate) + "%")])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Shop Intent:")]),
                  _c("h2", [_vm._v(_vm._s(_vm.upsellRatioNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.upsellRatio) + "%")])
                ])
              ])
            ])
          ]),
          _c("slide", [
            _c("div", { staticClass: "metrics-box" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-8" }, [
                  _c("h3", [_vm._v("Activities with Feedback")]),
                  _c("h2", [_vm._v(_vm._s(_vm.activitiesWithIssuesNumber))])
                ]),
                _c("div", { staticClass: "col-md-4" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.activitiesWithIssuesPercentage) + "%")
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }